/**
 * How long a snack bar should be presented.
 */
export const SNACKBAR_DURATION = 5000; // milliseconds

/**
 * Delay for mock service to simulate network latency.
 */
export const MOCK_NETWORK_DELAY = 1500; // milliseconds

/**
 * Number of milliseconds in a second.
 */
export const MILLISECONDS_PER_SECOND = 1000;
